/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/08/10 09:15
 * @update 2026/08/10 09:15
 */

import Api from "../../../services/api";

export function loadForm(params, cb) {
    return async () => {
        await Api.put('/w14f1021/load-form', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function onCalculateCommission(params, cb) {
    return async () => {
        await Api.put('/w14f1021/calculate-commission', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function onConfirm(params, cb) {
    return async () => {
        await Api.put('/w14f1021/confirm', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function onSave(params, cb) {
    return async () => {
        await Api.post('/w14f1021/save', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadCboObject(params, cb) {
    return async () => {
        await Api.put('/w14f1021/load-combo-object', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}